import {styled} from '@customink/pigment-react/lib/themeCustomink';

const ProductCardImage = styled('img', {
  shouldForwardProp: (prop) => prop !== 'cover'
})(({cover = false}) => ({
  '@media (min-width: 43.75em)': {
    aspectRatio: '1 / 1',
    maxHeight: 'unset'
  },
  maxHeight: '250px',
  minHeight: 120,
  objectFit: 'contain',
  order: 2,
  transitionDuration: '150ms',
  width: '100%',
  ...(cover && {
    aspectRatio: '1',
    objectFit: 'cover',
    objectPosition: 'top'
  })
}));

export default ProductCardImage;
